// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login_login-process__XK0kx {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  flex-direction: column;
  top: 18vh;
}
.login_logo__VyoBI {
  margin-top: 36px;
  margin-bottom: 69px;
}
.login_inner__uimB- {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  padding: 30px 12px;
  max-width: 500px;
  margin: 16px 0;
  border-radius: 20px;
  background: #2b0010;
  box-shadow: 0px 3px 16px 0px rgb(107 18 63);
  border: 2px solid #e868a8;
}

@media screen and (min-width: 1200px) {
  .login_login-process__XK0kx {
    /* justify-content: space-between; */
  }
  .login_inner__uimB- {
  }
}
`, "",{"version":3,"sources":["webpack://./src/Modals/login/login.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EAEd,mBAAmB;EACnB,mBAAmB;EACnB,2CAA2C;EAC3C,yBAAyB;AAC3B;;AAEA;EACE;IACE,oCAAoC;EACtC;EACA;EACA;AACF","sourcesContent":[".login-process {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  flex-direction: column;\n  top: 18vh;\n}\n.logo {\n  margin-top: 36px;\n  margin-bottom: 69px;\n}\n.inner {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  width: 100%;\n  padding: 30px 12px;\n  max-width: 500px;\n  margin: 16px 0;\n  border-radius: 16px;\n  border-radius: 20px;\n  background: #2b0010;\n  box-shadow: 0px 3px 16px 0px rgb(107 18 63);\n  border: 2px solid #e868a8;\n}\n\n@media screen and (min-width: 1200px) {\n  .login-process {\n    /* justify-content: space-between; */\n  }\n  .inner {\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"login-process": `login_login-process__XK0kx`,
	"logo": `login_logo__VyoBI`,
	"inner": `login_inner__uimB-`
};
export default ___CSS_LOADER_EXPORT___;
